// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { boolean, number, string, maybeString, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGetApiCalculatedFiltersAppGroupIdResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      type: string,
      status: anyOf(maybeString, nullOrUndefined),
      status_reason: anyOf(maybeString, nullOrUndefined),
      last_processed: anyOf(maybeString, nullOrUndefined),
      last_edited: string,
      last_edited_by: anyOf(
        objectOf({
          id: string,
          name: string,
          email: string,
        }),
        nullOrUndefined
      ),
      marked_as_deleted: boolean,
      is_draft: boolean,
      auto_disabled_at: anyOf(maybeString, nullOrUndefined),
    })
  ),
  hits: number,
  max_count: number,
  active_count: number,
});

const isPropertyFilterLeaf = objectOf({
  filter_key: string,
  name: string,
  type: string,
  comparator: number,
  complexity: string,
  value: anyOf(string, number, boolean, arrayOf(string), nullOrUndefined),
});

const isPropertyFilterGroup = objectOf({
  filter_key: string,
  filters: arrayOf(anyOf(isPropertyFilterLeaf, objectOf({ filter_key: string }))),
});

export const isCalculatedFilterLeaf = objectOf({
  filter_key: string,
  count: number,
  count_operator: string,
  y_days: number,
  property_filters: anyOf(isPropertyFilterGroup, nullOrUndefined),
});

export const isCalculatedFilterGroup = objectOf({
  filter_key: string,
  filters: arrayOf(anyOf(isCalculatedFilterLeaf, objectOf({ filter_key: string }))),
});

export const isCalculatedFilterDetail = objectOf({
  id: string,
  name: string,
  type: string,
  status: anyOf(maybeString, nullOrUndefined),
  status_reason: anyOf(maybeString, nullOrUndefined),
  last_processed: anyOf(maybeString, nullOrUndefined),
  last_edited: anyOf(maybeString, nullOrUndefined),
  last_edited_by: anyOf(
    objectOf({
      id: string,
      name: string,
      email: string,
    }),
    nullOrUndefined
  ),
  marked_as_deleted: boolean,
  is_draft: boolean,
  auto_disabled_at: anyOf(maybeString, nullOrUndefined),
  recurring_refresh_enabled: boolean,
  recurring_schedule: anyOf(objectOf({ frequency: string, start_minute: number }), nullOrUndefined),
  upcoming_refresh: anyOf(maybeString, nullOrUndefined),
  has_upcoming_auto_disable: anyOf(boolean, nullOrUndefined),
  date_range_type: anyOf(maybeString, nullOrUndefined),
  start_date: anyOf(maybeString, nullOrUndefined),
  end_date: anyOf(maybeString, nullOrUndefined),
  filters: anyOf(isCalculatedFilterGroup, nullOrUndefined),
  tag_names: anyOf(arrayOf(string), nullOrUndefined),
});

export const isPostApiCalculatedFiltersAppGroupIdResult = objectOf({
  calculated_filter: isCalculatedFilterDetail,
});
